import { useQuery } from '@tanstack/react-query';
import { analyticsApi } from '../api/analytics';
import { queryKeys } from '../lib/queryKeys';

export function useDashboardMetrics() {
  return useQuery({
    queryKey: queryKeys.analytics.dashboard,
    queryFn: () => analyticsApi.getDashboard(),
    refetchInterval: 60_000,
  });
}

export function useRevenueMetrics(days = 30) {
  return useQuery({
    queryKey: queryKeys.analytics.revenue(days),
    queryFn: () => analyticsApi.getRevenue(days),
  });
}

export function useUserMetrics(days = 30) {
  return useQuery({
    queryKey: queryKeys.analytics.users(days),
    queryFn: () => analyticsApi.getUsers(days),
  });
}

export function useProcessingMetrics(days = 30) {
  return useQuery({
    queryKey: queryKeys.analytics.processing(days),
    queryFn: () => analyticsApi.getProcessing(days),
  });
}

export function useTimeseries(metric: string, days = 30) {
  return useQuery({
    queryKey: queryKeys.analytics.timeseries(metric, days),
    queryFn: () => analyticsApi.getTimeseries(metric, days),
  });
}
